// The relation tree itself is assembled server-side (GET /courses/relation-tree,
// CREW-530); this module keeps only the course-option mapping for the
// add-relation form.
const getCourses = ({ courses, customCourses, groups }) => {
  const all = [];

  all.push(
    ...courses?.map((c) => ({
      id: c.id,
      name: c.name,
    })),
  );

  all.push(
    ...customCourses?.map((cc) => ({
      id: `cc_${cc.id}`,
      name: cc.name,
      isCustom: true,
    })),
  );

  all.push(
    ...groups?.map((gc) => ({
      id: `gc_${gc.id}`,
      name: gc.name,
      isGroup: true,
    })),
  );

  return all;
};

const RelationsService = {
  getCourses,
};

export default RelationsService;
